import { render, staticRenderFns } from "./languageInfo.vue?vue&type=template&id=aef75ea8&scoped=true"
import script from "./languageInfo.vue?vue&type=script&lang=js"
export * from "./languageInfo.vue?vue&type=script&lang=js"
import style0 from "./languageInfo.vue?vue&type=style&index=0&id=aef75ea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef75ea8",
  null
  
)

export default component.exports